import type { ReactNode } from 'react';

type ToastVariant = 'info' | 'success' | 'error';

interface ToastProps {
  variant: ToastVariant;
  children: ReactNode;
}

// Tinted wells on the brand-dark card: a low-alpha fill + hairline in
// the semantic hue, cream body text for contrast.
const VARIANT_CLASSES: Record<ToastVariant, string> = {
  info: 'bg-brand-orange/10 border-brand-orange/30',
  success: 'bg-success/10 border-success/30',
  error: 'bg-error/15 border-error/40',
};

export default function Toast({ variant, children }: ToastProps) {
  return (
    <div
      role={variant === 'error' ? 'alert' : 'status'}
      className={`rounded-md border px-3.5 py-2.5 text-sm text-brand-cream ${VARIANT_CLASSES[variant]}`}
    >
      {children}
    </div>
  );
}
